export default function epicConsoleLogger() {
  console.log(`
  what are you doing here...
                                    ,,
                             _,g╣╢Ñ╨╜╜╨╩╣@╖
                           ,@╣Ñ╜_        __╙╢H,
                         ╓╬╢╜_               _╙╣╖
                        ╫╢╜_                    \`╫,
                       ╣╢                         ╙%_
                      ╢╢                            ╙,,,,╖╖╥╖╥╥m╥╖,
                     ]╢[  ,         _ ,,╓,╓╖╥@@@╣╣╢╣╣Ñ╝╜╜╜╙╙╙"╙╙╙╜╜_
                      ╢╢╓▒▒╖m@@@ÑÑ╝╝╝╜╜╙╙"\` _____   ▒_
                       ║╢░__                         ▒
                      ]▒▒       ,              ╒▄    ╙_
                      ▒▒_       ▀▀              __    ▒
                      ▒▒                              ▒░
                      ▒▒_    _                      ╓@_▒
                      '▒▒     *╖                  ▄█▀__▒
                       _▒▒.     ╙▀▄,        _,▄▄█▀\`_  ]▒
                         ╙▒▒╖      _\`╙▀▀▀Ñ▀▀▀▀ __     ▒▒
                           _╙▒▒h,                    ▒▒_
                             @_\`╜▒▒╖╖._            ╓▒▒_
                            ]H    _\`╙╜▒▒▒∩╖╖╓╓╓╖H▒▒╜▒
                            ╟H          _ \`"╙"\`\`    ╢_
                            ╫_                      ╫_
                            ╣                       ╢
                           ]▓    ╫             ╢   _╣
                           ╟▌    ╣             ╫_  ]╣_
                           ╫[   j╣             ╫   ]╣_
                           ╫L   ]▓             ╫_  ╟▓_
                           ╫U   ╟▓             ╫H  ╟╣_
                          ]╣_   ╫▌             ╫[  ╟╢_
                          ]▓    ▓[             ╫H  ╟▓_
                          ]╣_   ╫[             ╢@,,▓╩
                           ▓▓ ,,╣[            _╫[_\`_
                           _╙╙╙_╣[            _▓@
                               j╣[              ∩
                               ]╣L       ]      [
                                ╙        ╟[     [
                                ╟_       ║[    ][
                                ╫_       ║╝    ][
                                ╢_       ]▒    ╟[
                                ▓        ╟╣    ╟C
                                ▓_       ╟╣    ╫L
                               ]▓_       ╟[    ▓C
                               ▐▓        ╫H    ▓U
                               ╟[        ▓_   _▓
                               ▓[       ]▓_    ▓_
                              j▓_       ╟▌     ▓∩
                              ╙╣        ╫▌    ]╢C
                               ▐,       ╓▄     ▀█▄
                                ▀▄       ▀█▄    _██_
                                 ╙▓,       ▀█,    ▀█
                                   ▀█,      ╙█▄    ▓▌
                                    _▀█,     _██N▄,▓▀
                                       ▀█▄    j█____
                                         \`▀██▄█▀_
                                             _
  `);
}
